import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disconnect() {
    clearTimeout(this.searchTimer)
  }

  apply(event) {
    if (event.target.type === "search") return
    clearTimeout(this.searchTimer)
    const form = event.target.form
    if (!form?.checkValidity()) return
    const from = form.elements.namedItem("from")?.value
    const to = form.elements.namedItem("to")?.value
    if (from && to && from > to) return
    form.requestSubmit()
  }

  search(event) {
    if (event.target.type !== "search") return
    clearTimeout(this.searchTimer)
    this.searchTimer = setTimeout(() => event.target.form.requestSubmit(), 300)
  }

  positionMenu(event) {
    const menu = event.target
    if (!menu.open) return
    const panel = menu.lastElementChild
    const anchor = menu.firstElementChild.getBoundingClientRect()
    panel.style.left = `${Math.max(8, Math.min(anchor.left, window.innerWidth - panel.offsetWidth - 8))}px`
    panel.style.top = `${anchor.bottom + 8}px`
  }

  closeMenus(event) {
    this.element.querySelectorAll("details[name='admin-period'][open]").forEach((menu) => {
      if (event.key === "Escape" || !menu.contains(event.target)) menu.open = false
    })
  }
}
